import React, { useEffect, useState } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_LOW,
  REDO_COMMAND,
  UNDO_COMMAND,
} from 'lexical';
import { mergeRegister } from '@lexical/utils';

import { Icon } from '../../../../Icon';
import { Box } from '../../../../Box';
import { ToolbarButton } from '../common';

export const UndoRedoPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const [canUndo, setCanUndo] = useState<boolean>(false);
  const [canRedo, setCanRedo] = useState<boolean>(false);

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        CAN_UNDO_COMMAND,
        (payload) => {
          setCanUndo(payload);
          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        CAN_REDO_COMMAND,
        (payload) => {
          setCanRedo(payload);
          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    );
  }, [editor]);

  const handleClick = (command: 'undo' | 'redo') => () => {
    if (command === 'undo' && canUndo) {
      editor.dispatchCommand(UNDO_COMMAND, undefined);

      return;
    }

    if (command === 'redo' && canRedo) {
      editor.dispatchCommand(REDO_COMMAND, undefined);

      return;
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <ToolbarButton onClick={handleClick('undo')} tooltip="Отменить действие">
        <Icon
          name="arrow_uturn_left_outline"
          size="16"
          color={canUndo ? 'text.light.primary' : 'text.light.tertirary'}
        />
      </ToolbarButton>
      <ToolbarButton onClick={handleClick('redo')} tooltip="Повторить действие">
        <Icon
          name="arrow_uturn_right_outline"
          size="16"
          color={canRedo ? 'text.light.primary' : 'text.light.tertirary'}
        />
      </ToolbarButton>
    </Box>
  );
};
